<template>
  <div id="loading" v-if="loading.Data" class="d-flex flex-column loading-wrp">
    <spinner-loading></spinner-loading>
  </div>
  <div v-else id="dashborad-card" class="h-100 w-100">
    <div
      class="body-card-wrp d-flex flex-column justify-content-between h-100 w-100"
    >
      <div>
        <div
          class="d-flex justify-content-between overall-card-content-tiltle-wrp"
        >
          <div class="overall-card-title">
            {{ resoveTitle(config.id) }}
          </div>
          <div>
            <div
              class="overall-card-content-title"
              v-if="
                resolveLabelEqualType(
                  renderData.jsonOverride.Right_Title,
                  renderData.jsonOverride.Button_Right_Title
                )
              "
            >
              <div
                class="text-reward-type"
                v-if="renderData.jsonOverride.Right_Title == TYPE.NOT_REWARD"
              >
                ไม่มีของรางวัล
              </div>
              <div v-else>
                <span class="text-reward-type">สมาชิก</span
                ><span class="text-underline-reward-type">{{
                  resolveLabelEqualType(
                    renderData.jsonOverride.Right_Title,
                    renderData.jsonOverride.Button_Right_Title
                  )
                }}</span>
              </div>
            </div>
            <div class="d-flex justify-content-end">
              <div
                class="overall-card-content-reward"
                v-if="renderData.jsonOverride.Button_Right_Title"
              >
                <div>
                  {{
                    resoveLabelType(renderData.jsonOverride.Button_Right_Title)
                  }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="overall-card-content-value p-relative">
        <div class="text-center d-flex justify-content-center">
          <div class="overall-card-value">
            {{ formatter.format(renderData.data) }}
          </div>
          <div class="overall-card-unit" v-if="config.id == 'card_default_1'">
            {{ "คน" }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { formatter } from "@/utils/scripts/format-currency";
import {
  watch,
  reactive,
  onMounted,
  getCurrentInstance,
  onBeforeMount,
} from "@vue/composition-api";

import router from "@/router";
import store from "@/store";

import quizListModel from "@/models/survey-quiz/quiz-list";
import surveyModel from "@/models/survey-quiz/survey";

import useValidationModal from "@/@core/components/base-modal/hooks/useValidationModal";
export default {
  props: {
    config: { default: {} },
    layoutData: { default: {} },
    data: { default: {} },
  },
  setup(props) {
    const { fetchQueryDataDashboard } = quizListModel();

    const { fetchQueryDataDashboard: fetchQueryDataSurveyDashboard } =
      surveyModel();

    const { openDefaultErrorModal } = useValidationModal();

    const loading = reactive({
      Data: false,
    });

    const renderData = reactive({
      data: [],
      jsonOverride: {},
    });

    const formData = reactive({
      groupId: "",
      moduleName: "",
    });

    const MODULENAME = reactive({
      QUIZ: "QuizDashboard",
      SURVEY: "SurveyDashboard",
    });

    const resolveChartModule = (moduleName, GroupId) => {
      switch (moduleName) {
        case MODULENAME.QUIZ:
          fetchDashboradDetail(GroupId);
          return;
        case MODULENAME.SURVEY:
          fetchDashboradSurveyDetail(GroupId);
          return;
      }
    };

    const fetchDashboradDetail = (GoupId) => {
      loading.Data = true;
      const payload = {
        CardId: props.config.id,
        Quiz_GroupId: GoupId,
        QuestionId: props.config.payload.query_data.id,
        Key: props.config.payload.query_data.key,
      };

      fetchQueryDataDashboard.payload = payload;

      store
        .dispatch("api/apiRequest", fetchQueryDataDashboard)
        .then((response) => {
          renderData.data = response.data.list[0].value;
          renderData.jsonOverride = JSON.parse(response.data.jsonoverride);
        })
        .catch((error) => {
          openDefaultErrorModal(error);
        })
        .finally(() => {
          loading.Data = false;
        });
    };

    const fetchDashboradSurveyDetail = (GoupId) => {
      loading.Data = true;
      const payload = {
        CardId: props.config.id,
        Survey_GroupId: GoupId,
        QuestionId: props.config.payload.query_data.id,
        Key: props.config.payload.query_data.key,
      };

      fetchQueryDataSurveyDashboard.payload = payload;

      store
        .dispatch("api/apiRequest", fetchQueryDataSurveyDashboard)
        .then((response) => {
          renderData.data = response.data.list[0].value;
          renderData.jsonOverride = JSON.parse(response.data.jsonoverride);
        })
        .catch((error) => {
          openDefaultErrorModal(error);
        })
        .finally(() => {
          loading.Data = false;
        });
    };

    const TYPE = reactive({
      EQUAL: "card.button_right_title.equal",
      NOT_EQUAL: "card.button_right_title.notequal",
      POINT: "card.right_title.point",
      PRIVILEGE: "card.right_title.privilege",
      NOT_REWARD: "card.right_title.notreward",
    });

    const resolveLabelEqualType = (equal, type) => {
      switch (type) {
        case TYPE.POINT:
          if (equal == TYPE.EQUAL) return "ได้แต้มเท่ากัน";
          else if (equal == TYPE.NOT_EQUAL) return "ได้แต้มไม่เท่ากัน";
          break;
        case TYPE.PRIVILEGE:
          if (equal == TYPE.EQUAL) return "ได้ของรางวัลเท่ากัน";
          else if (equal == TYPE.NOT_EQUAL) return "ได้ของรางวัลไม่เท่ากัน";
          break;
        default:
          return;
      }
    };

    const resoveLabelType = (type) => {
      switch (type) {
        case TYPE.POINT:
          return "Point";
        case TYPE.PRIVILEGE:
          return "Privilege";
      }
    };

    const CARDID = reactive({
      CARD_1: "card_default_1",
      CARD_2: "card_default_2",
    });

    const resoveTitle = (cardId) => {
      switch (cardId) {
        case CARDID.CARD_1:
          return "จำนวนคนตอบคำถามทั้งหมด";
        case CARDID.CARD_2:
          return "จำนวนของรางวัล หรือ แต้ม";
      }
    };

    onBeforeMount(() => {
      formData.groupId = parseInt(router.currentRoute.params.ref);
      formData.moduleName = props.layoutData.module_name;

      resolveChartModule(formData.moduleName, formData.groupId);
    });

    return {
      formatter,
      loading,
      renderData,
      resolveLabelEqualType,
      resoveLabelType,
      resoveTitle,
      TYPE,
    };
  },
};
</script>

<style>
#loading.loading-wrp {
  min-height: 240px !important;
}

#dashborad-card .body-card-wrp {
  padding: 10px 20px 70px 20px;
}

#dashborad-card .overall-card-content-tiltle-wrp {
  margin-bottom: 5px;
}

#dashborad-card .overall-card-title {
  text-align: left;
  font-size: 21px;
  font-weight: bold;
  color: rgb(0, 0, 0);
}

#dashborad-card .overall-card-content-title {
  padding: 5px 25px;
  border-radius: 8px;
  height: 35px;
  display: flex;
  align-items: center;
  background-color: #e6ecf3;
  font-size: 21px;
  margin-bottom: 10px;
}

#dashborad-card .overall-card-content-reward {
  padding: 5px 32px;
  border-radius: 8px;
  background-color: #e5e5e5;
  font-size: 21px;
  color: #000;
  font-weight: bold;
  height: 35px;
  display: flex;
  align-items: center;
}

#dashborad-card .overall-card-content-value {
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
  line-height: 1;
  margin-top: 30px;
}

#dashborad-card .overall-card-value {
  text-align: center;
  font-size: 45px;
  font-weight: bold;
  color: #000000 !important;
}

#dashborad-card .overall-card-unit {
  font-size: 16px;
  font-weight: bold;
  color: #000;
  text-align: center;
  position: absolute;
  bottom: -10px;
}

#dashborad-card .text-reward-type {
  color: #09458b;
}

#dashborad-card .text-underline-reward-type {
  color: #09458b;
  font-weight: bold;
  text-decoration: underline;
}
</style>